import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";
import {Response} from "@/hooks/services/queries/types";

type BannerContents = {
	title: string;
	bgAttaFileKey: string;
	imgPath: string;
	mImgPath: string;
	alt: string;
	mAlt: string;
	link: string;
	mLink: string;
	target: string;
	mTarget: string;
};

/** ```
 * 콘텐츠 구분 코드 배너 목록 조회
 *   `/pkg/common/contents/${diviCd}`
 * parameter
 * 		diviCd : WEB_CONT_DIVI_CD 공통코드값
 * ```*/
const key = "useBannerContents";
const getPath = (diviCd: string): string | null =>
	`${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/common/contents/${diviCd}`;

/** ```
 * 콘텐츠 구분 코드 배너 목록 조회 SSR
 *   `/pkg/common/contents/${diviCd}`
 * parameter
 * 		diviCd : WEB_CONT_DIVI_CD 공통코드값
 * ```*/
const bannerContentsSSR = (diviCd: string) => useConfigureAxios(getPath(diviCd));

/** ```
 * 콘텐츠 구분 코드 배너 목록 조회
 *   `/pkg/common/contents/${diviCd}`
 * parameter
 * 		diviCd : WEB_CONT_DIVI_CD 공통코드값
 * ```*/
const useBannerContents = (diviCd: string, options?: Partial<UseQueryOptions<Response<BannerContents[]>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(diviCd)],
		queryFn: () => useConfigureAxios({url: getPath(diviCd)}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		...options,
	});

export default useBannerContents;
export {getPath, bannerContentsSSR};
export type {BannerContents};
